import { IConfiguracaoFinanceiraDom } from "src/components/pagamento/financiamento/types";
import { IFormalizacao } from "src/components/pagamento/negociacao/FinanciamentoDocumentos/type";
import api, { IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { AProvider } from "src/framework/providers/AProvider";
import { FinanciamentoProposta, FinanciamentosType, FinanciamentosUploadsType } from "src/types";

class FinanciamentosProvider extends AProvider {
    constructor() {
        super("/pagamentos/financiamentos");
    }

    async getProfissoes(): Promise<IDataResponse> {
        try {
            const response: IDataResponse = await api.get({
                url: `${this.path}/profissoes`
            });

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao consultar lista de profissões",
                statusCode: 404
            }
        }
    }

    async getProfissoesFinanceira(financeira_id: number): Promise<IDataResponse> {
        try {
            const response: IDataResponse = await api.get({
                url: `${this.path}/profissoes/${financeira_id}`
            });

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao consultar lista de profissões",
                statusCode: 404
            }
        }
    }

    async getConfigFinanceira(financeira_id: number): Promise<IDataResponse<IConfiguracaoFinanceiraDom[] | null>> {
        try {
            const response: IDataResponse = await api.get({
                url: `/financeiro/financeiras/${financeira_id}`
            });

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao consultar configurações dos avalistas",
                statusCode: 404
            }
        }
    }

    async getFinanciamentoProposta(codigo_venda: string): Promise<IDataResponse> {
        try {

            const response: IDataResponse = await api.get({
                url: `/pagamentos/financiamentos/propostas/financeiras/${codigo_venda}`
            })

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao consultar dados da proposta",
                statusCode: 404
            }
        }
    }

    async salvarProposta(data: FinanciamentoProposta, codigo_venda: string): Promise<IDataResponse> {
        try {
            const response: IDataResponse = await api.put({
                url: `/pagamentos/financiamentos/propostas/financeiras/${codigo_venda}`,
                data: data
            });

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao salvar dados de proposta",
                statusCode: 404
            }
        }
    }

    async enviarProposta(codigo_venda: string): Promise<IDataResponse> {
        try {
            const response: IDataResponse = await api.post({
                url: `/pagamentos/financiamentos/propostas/envio/financeiras/${codigo_venda}`,
            });

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao enviar proposta",
                statusCode: 404
            }
        }
    }

    async getDocumentos(financiamento_id: number): Promise<IDataResponse> {
        try {
            const response: IDataResponse = await api.get({
                url: `/pagamentos/financiamentos/uploads/documentos/${financiamento_id}`,
            });

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao enviar proposta",
                statusCode: 404
            }
        }
    }

    async getPlanos(financiamento_id: number): Promise<IDataResponse> {
        try {
            const response: IDataResponse = await api.get({
                url: `/pagamentos/financiamentos/planos/listar/${financiamento_id}`,
            });

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao enviar proposta",
                statusCode: 404
            }
        }
    }

    async putUploads(id: string, upload: FinanciamentosUploadsType): Promise<IDataResponse> {
        try {
            const response: IDataResponse = await api.put({
                url: `/pagamentos/financiamentos/uploads/${id}`,
                data: upload,
            });

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao enviar proposta",
                statusCode: 404
            }
        }
    }

    async putFinanciamento(id: string, data: FinanciamentosType): Promise<IDataResponse> {
        try {
            const response: IDataResponse = await api.put({
                url: `/pagamentos/financiamentos/${id}`,
                data,
            });

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao enviar proposta",
                statusCode: 404
            }
        }
    }

    async putEnviarDocumentos(id: string, id_plano: number, codigo_venda: string): Promise<IDataResponse> {
        try {
            const response: IDataResponse = await api.put({
                url: `/pagamentos/financiamentos/documentos/enviar/${id}`,
                data: {
                    id_plano,
                    codigo_venda, 
                }
            });

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao enviar proposta",
                statusCode: 404
            }
        }
    }

    async enviaPlano(id_plano: number, financiamento_id: number) : Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: `/pagamentos/financiamentos/planos/enviar/${financiamento_id}`,
                data: {
                    id_plano
                }
            }
            const response: IDataResponse = await this.httpClient.put(request);

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao salvar o plano",
                statusCode: STATUS_CODE.BAD_REQUEST
            }
        }
    }

    async verificarSituacaoAssinatura(financiamento_id: number): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: `/pagamentos/financiamentos/planos/enviar/${financiamento_id}`,
            }
            const response: IDataResponse = await this.httpClient.get(request);

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao verificar situação da assinatura",
                statusCode: STATUS_CODE.BAD_REQUEST
            }
        }
    }

    async gerarNovoLinkAssinatura(financiamento_id: number): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: `/pagamentos/financiamentos/assinatura/gerar/${financiamento_id}`,
            }
            const response: IDataResponse = await this.httpClient.put(request);

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao verificar situação da assinatura",
                statusCode: STATUS_CODE.BAD_REQUEST
            }
        }
    }

    async getFormalizacaoDocumentos(financiamento_id: number): Promise<IDataResponse<IFormalizacao | null>> {
        try {
            const response: IDataResponse = await api.get({
                url: `/pagamentos/financiamentos/uploads/formalizacao/${financiamento_id}`,
            });

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao enviar proposta",
                statusCode: 404
            }
        }
    }
    

}
export const financiamentosProvider = new FinanciamentosProvider()
export { FinanciamentosProvider }